import Modal from "../Modal";
import CrudForm from "./CrudForm";

function CrudModal({ isOpen, onClose, mode, title, schema, initialValues, isSubmitting, onSubmit, onValuesChange, closeOnOutsideClick = true }) {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={title || (mode === "edit" ? "Edit Record" : "Create Record")}
      closeOnOutsideClick={closeOnOutsideClick}
    >
      <CrudForm
        mode={mode}
        schema={schema}
        initialValues={initialValues}
        isSubmitting={isSubmitting}
        onSubmit={onSubmit}
        onCancel={onClose}
        onValuesChange={onValuesChange}
      />
    </Modal>
  );
}

export default CrudModal;
